module.exports = __webpack_public_path__ + "img/eresidency.09163d15.svg";